import axios from "axios";
import ScrollHandler from "../../../src/parts/ScrollHandler";
import RoutemParticleHandler from "../../../src/parts/RoutemParticleHandler";
const scrollHandler = new ScrollHandler();
const routemParticleHandler = new RoutemParticleHandler();

// add needed click, change, and submit events to modal form and triggers after DOM is loaded
window.addEventListener("DOMContentLoaded", () => {
  // The header will pass in >= 1 form obj, so we account for as many as needed
  for (let formObj in formsArr) {
    // Referenced frequently in this loop, also in submit function (could be shifted to not be stored as att in obj, if desired)
    let containerEl;
    switch (loadingType) {
      case "popup":
        containerEl = document.querySelector(
          "#" + formsArr[formObj].modalObj.id
        );
        break;
      case "fullpage":
        containerEl = document.querySelector(
          "#" + formsArr[formObj].containerID
        );
        containerEl.innerHTML = output;
        break;
      default:
        containerEl = null;
        break;
    }

    formsArr[formObj].containerEl = containerEl;

    let formEl = containerEl.querySelector("form");
    formsArr[formObj].formEl = formEl;

    // used to support deprecated form in addition to new form for testing purposes
    formsArr[formObj].classRoot = formsArr[formObj].deprecated
      ? "c-demo-form"
      : "c-form-popup";

    // Modal form submission event
    formEl.addEventListener("submit", (e) => {
      formPopupSubmit(e, formEl);
    });

    // Try again server error event, if present (to support old form)
    if (
      loadingType == "popup" &&
      containerEl.querySelector("#try-again--" + formsArr[formObj].slug)
    ) {
      containerEl
        .querySelector("#try-again--" + formsArr[formObj].slug)
        .addEventListener("click", (e) => {
          formPopupSubmit(e, formEl);
        });
    }

    // On-page trigger events, both for a staged CTA form and a simple button (handled by other) - if we're loading a popup form
    if (loadingType == "popup") {
      for (let triggerID in formsArr[formObj].modalObj.triggerIDs) {
        if (
          formsArr[formObj].modalObj.triggerIDs[triggerID] == "stagedCTAform"
        ) {
          // Specific trigger behavior for the one-field form that grabs users' emails and passes it into the modal form (staged CTA or DCE/Direct Conversion Experience)
          let form = document.querySelector("#" + triggerID);

          form.addEventListener("submit", (e) => {
            e.preventDefault();

            // Handle validity, assumes only one email field
            if (!form.stagedEmail.validity.valid) {
              form.stagedEmail.setAttribute("error", "true");
              return;
            }

            // Updated value would not render on email field in modal form unless a change event is dispatched to it
            let event = new Event("change");
            containerEl.querySelector('input[name="email"]').value =
              form.stagedEmail.value;
            containerEl
              .querySelector('input[name="email"]')
              .dispatchEvent(event);

            routemParticleHandler.logGetDemoButtonTappedEvent(
              form.getAttribute("location_source_name"),
              document.getElementById("business-email")?.value
            );
            customOpenModal(formsArr, formObj);
          });

          // Remove error from staged CTA email field when resolved
          form.stagedEmail.addEventListener("input", (e) => {
            if (
              e.target.getAttribute("error") == "true" &&
              e.target.validity.valid
            ) {
              e.target.removeAttribute("error");
            }
          });
        } else if (
          formsArr[formObj].modalObj.triggerIDs[triggerID] == "button"
        ) {
          console.log(formsArr);
          // For simple button triggers, just open the modal and send the mParticle event
          document
            .querySelector("#" + triggerID)
            ?.addEventListener("click", (e) => {
              routemParticleHandler.logGetDemoButtonTappedEvent(
                e.target.getAttribute("location_source_name"),
                document.getElementById("business-email")?.value
              );
              customOpenModal(formsArr, formObj);
            });
        }
      }
    }

    // Store the DOM el for each field in formObj, and add validity checks on change
    for (let field in formsArr[formObj].modalObj.fields) {
      let fieldObj = formsArr[formObj].modalObj.fields[field];

      // Each call grabs the errSpan and passes it to handleValidity(), and while each type looks similar they have some subtle differences
      // radio types need to be given the event for each input element in the group
      // select types also manually updates a "val" attribute on the el used to enable the responsive material design label to move when a "val" value is present
      // -- This switch can be extended for future field types as needed
      switch (fieldObj.fieldType) {
        case "text":
          fieldObj.fieldEl = formEl.querySelector(`input[name="${field}"]`);
          fieldObj.errSpan = formEl.querySelector(
            "." + formsArr[formObj].classRoot + `__error[data-for="${field}"]`
          );
          fieldObj.fieldEl.addEventListener("change", (e) => {
            handleValidity(e.target, fieldObj.errSpan);
          });
          break;
        case "radio":
          fieldObj.fieldEl = formEl.querySelectorAll(`input[name="${field}"]`);
          fieldObj.errSpan = formEl.querySelector(
            "." + formsArr[formObj].classRoot + `__error[data-for="${field}"]`
          );
          fieldObj.fieldEl.forEach((fieldChild) => {
            fieldChild.addEventListener("change", (e) => {
              handleValidity(fieldObj.fieldEl, fieldObj.errSpan, true);
            });
          });
          break;
        case "select-one":
          fieldObj.fieldEl = formEl.querySelector(`select[name="${field}"]`);
          fieldObj.errSpan = formEl.querySelector(
            "." + formsArr[formObj].classRoot + `__error[data-for="${field}"]`
          );
          fieldObj.fieldEl.addEventListener("change", (e) => {
            handleValidity(e.target, fieldObj.errSpan);
            e.target.setAttribute("val", e.target.value);
          });
          break;
      }

      // Add showing/hiding of forked els to the fork trigger change event. assumes forkTrigger is a radio field type
      // Shows selected option, hides the rest
      if (fieldObj.forkTrigger) {
        let opt;

        fieldObj.fieldEl.forEach((fieldChild) => {
          fieldChild.addEventListener("change", (e) => {
            for (let forkOpt in fieldObj.forkOpts) {
              formEl
                .querySelectorAll(".forked--" + fieldObj.forkOpts[forkOpt])
                .forEach((forkedEl) => {
                  if (forkOpt == e.target.value) {
                    forkedEl.classList.contains("forked")
                      ? forkedEl.classList.remove("forked")
                      : null;
                    opt = fieldObj.forkOpts[forkOpt];
                  } else {
                    forkedEl.classList.contains("forked")
                      ? null
                      : forkedEl.classList.add("forked");
                  }
                });
            }

            // Additional behavior depending on which option was chosen (can be added onto)
            switch (opt) {
              case "merchant":
                formEl.submit.removeAttribute("disabled");
                formEl.submit.style.display = "inline-block";
                formEl.querySelector("#recaptcha_notice").style.display =
                  "block";
                routemParticleHandler.logMerchantButtonTappedEvent(
                  formsArr[formObj].formVersion,
                  formEl.querySelector("#form__business_email_modal").value // get specific value from submitted form
                );
                break;
              case "shopper":
                formEl.submit.setAttribute("disabled", "disabled");
                formEl.submit.style.display = "none";
                formEl.querySelector("#recaptcha_notice").style.display =
                  "none";
                break;
            }

            containerEl.setAttribute("forkCompleted", opt);
          });
        });
      }
    }

    if (loadingType == "popup") {
      // Close modal when user clicks outisde of the modal
      containerEl.addEventListener("click", (event) => {
        if (
          event.target === containerEl &&
          event.target !==
            containerEl.querySelector(
              "." + formsArr[formObj].classRoot + "__contents"
            )
        ) {
          customCloseModal(formsArr, formObj);
        }
      });

      // Close modal when user clicks 'Close' text inside modal
      formEl.parentElement
        .querySelector("." + formsArr[formObj].classRoot + "__close")
        .addEventListener("click", (e) => {
          customCloseModal(formsArr, formObj);
        });

      // Close modal when user clicks outside of modal in a fallback state
      document
        .querySelector(
          "#" +
            formsArr[formObj].classRoot +
            "__fallback-backdrop--" +
            formsArr[formObj].slug
        )
        .addEventListener("click", () => {
          customCloseModal(formsArr, formObj);
        });

      // Close modal when user presses 'Escape'
      document.addEventListener("keydown", (e) => {
        if (formsArr[formObj].modalObj.open && e.keyCode == "27") {
          customCloseModal(formsArr, formObj);
        }
      });
    }
  }
});

// Assembles data and sends to REST API endpoint for popup forms
function formPopupSubmit(e, form) {
  e.preventDefault();

  let valid = true;
  let fields,
    hsFormID,
    nonce,
    container,
    serverErrSpan,
    classRoot,
    formVersion,
    formSlug;

  // find which form was passed in and grab a few attributes from main array
  for (let formObj in formsArr) {
    if (formsArr[formObj].formEl == form) {
      fields = formsArr[formObj].modalObj.fields;
      hsFormID = formsArr[formObj].hsFormID;
      nonce = {
        name: formsArr[formObj].modalObj.id,
        val: formsArr[formObj].formEl.querySelector(
          "#" + formsArr[formObj].modalObj.id
        ).value,
      };
      container = formsArr[formObj].containerEl;
      serverErrSpan = container.querySelector("#server-side-error");
      classRoot = formsArr[formObj].classRoot;
      formVersion = formsArr[formObj].formVersion;
      formSlug = formObj; // save the form slug, this will be used later to select the proper email value across forms
    }
  }

  const formEmail = document.querySelector(
    `#formPopupDefault--${formSlug} #form__business_email_modal`
  )?.value; // get the specific email value across initialized forms after submit

  // Event is fired when submit process is started (name is a little misleading)
  routemParticleHandler.logDelayedmParticleEvent(
    "Dotcom-DemoLeadForm-RequestDemo-Button-Tapped",
    {
      screen_name: routemParticleHandler.getScreenName(),
      demoleadform_version: formVersion,
      device_platform: routemParticleHandler.getDevicePlatform(),
      email: formEmail,
    }
  );

  // manually handle validity
  for (let field in fields) {
    let errSpan = fields[field].errSpan;

    if (fields[field].fieldType != "radio") {
      !handleValidity(fields[field].fieldEl, errSpan) ? (valid = false) : null;
    } else {
      !handleValidity(fields[field].fieldEl, errSpan, true)
        ? (valid = false)
        : null;
    }
  }

  if (!valid) {
    routemParticleHandler.logDemoFormSubmittedEvent("invalidfields", formEmail);
    return;
  }

  // // Init reCAPTCHA
  grecaptcha.ready(function () {
    grecaptcha
      .execute("6LfWktgjAAAAAF4E4N9mx0tPBqKzJa6nruy-uQsZ", {
        action: "demoSubmit",
      })
      .then(async function (token) {
        // Construct payload
        // we start with the hidden fields (shouldn't change, if they do that will have to be updated here)
        // then add context and info needed for request made on server-side
        // finally, iterate through each field and grab its value depending on what type of field it is
        let data = {
          hsData: {
            fields: [
              {
                objectTypeId: "0-1",
                name: "utm_source",
                value: form.utm_source.value,
              },
              {
                objectTypeId: "0-1",
                name: "utm_medium",
                value: form.utm_medium.value,
              },
              {
                objectTypeId: "0-1",
                name: "utm_campaign",
                value: form.utm_campaign.value,
              },
              {
                objectTypeId: "0-1",
                name: "utm_content",
                value: form.utm_content.value,
              },
              {
                objectTypeId: "0-1",
                name: "utm_term",
                value: form.utm_term.value,
              },
              {
                objectTypeId: "0-1",
                name: "last_offer",
                value: form.last_offer.value,
              },
              {
                objectTypeId: "0-1",
                name: "first_page_seen__c",
                value: form.first_page_seen__c.value,
              },
              {
                objectTypeId: "0-1",
                name: "conversion_page__c",
                value: form.conversion_page__c.value,
              },
              {
                objectTypeId: "0-1",
                name: "gclid",
                value: form.gclid.value,
              },
              {
                objectTypeId: "0-1",
                name: "msclkid",
                value: form.msclkid.value,
              },
              {
                objectTypeId: "0-1",
                name: "fbclid",
                value: form.fbclid.value,
              },
              {
                objectTypeId: "0-1",
                name: "salesforce_sync",
                value: form.salesforce_sync.value,
              },
            ],
            context: {
              hutk: getCookie("hubspotutk"),
              pageUri: pageInfo.pageUri,
              pageName: pageInfo.pageName,
            },
          },
          nonce: nonce,
          hsFormID: hsFormID,
          recaptchaToken: token,
          whitelisted_secret: getCookie("whitelisted_secret"),
        };

        for (let field in fields) {
          let valToPush;

          // if more types of fields are supported later, consider making this a switch instead
          if (
            fields[field].fieldType == "text" ||
            fields[field].fieldType == "select-one"
          ) {
            valToPush = fields[field].fieldEl.value;
          } else if (fields[field].fieldType == "radio") {
            fields[field].fieldEl.forEach((fieldChild) => {
              if (fieldChild.checked) {
                valToPush = fieldChild.value;
              }
            });
          }

          // format data properly for server-side request
          data.hsData.fields.push({
            objectTypeId: "0-1",
            name: field,
            value: valToPush,
          });
        }

        // Sends the request to custom REST API endpoint
        axios.defaults.headers.common["X-WP-Nonce"] = pageInfo.nonce;
        try {
          const response = await axios.post(
            pageInfo.siteURL + "/wp-json/forms/v1/submit",
            data
          );
          if (response.data == "Submitted successfully!") {
            if (serverErrSpan) {
              serverErrSpan.style.display = "none";
            }
            routemParticleHandler.logDelayedmParticleEvent(
              "DemoFormSubmitted",
              {
                status: "successful",
                email: formEmail,
              }
            );
            window.location.href = pageInfo.siteURL + "/thank-you-demo";
          } else {
            if (serverErrSpan) {
              serverErrSpan.style.display = "inline";
              container.scrollTo(0, 0);
            } else {
              alert("Something went wrong. Please try again!");
            }
            routemParticleHandler.logDemoFormSubmittedEvent(
              "server",
              formEmail
            );
          }
        } catch (e) {
          serverErrSpan.style.display = "inline";
          container.scrollTo(0, 0);
          routemParticleHandler.logDemoFormSubmittedEvent("server", formEmail);
        }
      });
  });
}

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}

// if more field types are supported in the future, will want to flesh out to more flexible than just 'isRadio'
// radio els need to be iterated through and each input checked for validity
function handleValidity(target, errSpan, isRadio = false) {
  console.log("Validating field:", target.name);
  console.log("errSpan:", errSpan);
  let valid = true;
  let errMsg = "";

  if (!isRadio) {
    // Check if the field is required and empty
    if (target.hasAttribute("required") && target.value.trim() === "") {
      valid = false;
      errMsg = "*required";
      errSpan.textContent = errMsg;
      target.setAttribute("error", true);
    } else {
      // Field is not empty (or not required)
      // Perform custom validation
      if (target.name === "phone") {
        if (target.value.trim() !== "") {
          const phoneValue = target.value.replace(/\D/g, ""); // Remove non-digit characters
          if (phoneValue.length < 10) {
            valid = false;
            errMsg = "Enter a valid phone number with at least 10 digits";
            errSpan.textContent = errMsg;
            target.setAttribute("error", true);
          } else {
            // Field is valid
            errSpan.textContent = "";
            target.removeAttribute("error");
          }
        } else {
          // Field is empty and not required
          errSpan.textContent = "";
          target.removeAttribute("error");
        }
      } else if (target.name === "website") {
        // The website field is required, so we can assume it's not empty
        // Let's check if it's a valid domain or URL
        const urlValue = target.value.trim();
        const domainPattern =
          /^(?:https?:\/\/)?(?:www\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i;
        if (!domainPattern.test(urlValue)) {
          valid = false;
          errMsg = "Enter a valid domain, e.g., example.com";
          errSpan.textContent = errMsg;
          target.setAttribute("error", true);
        } else {
          // Field is valid
          errSpan.textContent = "";
          target.removeAttribute("error");
        }
      } else if (target.type === "email") {
        // Validate email field
        const emailValue = target.value.trim();
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(emailValue)) {
          valid = false;
          errMsg = "Enter a valid email: name@example.com";
          errSpan.textContent = errMsg;
          target.setAttribute("error", true);
        } else {
          // Field is valid
          errSpan.textContent = "";
          target.removeAttribute("error");
        }
      } else {
        // For other fields, clear any previous errors
        errSpan.textContent = "";
        target.removeAttribute("error");
      }
    }
  }

  // Radio button validation
  if (isRadio) {
    let groupValid = false;
    for (let i = 0; i < target.length; i++) {
      if (target[i].checked) {
        groupValid = true;
        break;
      }
    }
    if (!groupValid) {
      valid = false;
      errMsg = "*required";
      errSpan.textContent = errMsg;
      // Set error attribute on all radio buttons
      for (let i = 0; i < target.length; i++) {
        target[i].setAttribute("error", true);
      }
      // Also set error on legend if present
      if (target[0].parentElement.parentElement.querySelector("legend")) {
        target[0].parentElement.parentElement
          .querySelector("legend")
          .setAttribute("error", true);
      }
    } else {
      // Valid
      errSpan.textContent = "";
      for (let i = 0; i < target.length; i++) {
        target[i].removeAttribute("error");
      }
      if (target[0].parentElement.parentElement.querySelector("legend")) {
        target[0].parentElement.parentElement
          .querySelector("legend")
          .removeAttribute("error");
      }
    }
  }

  return valid;
}

function customOpenModal(formsArr, formObj) {
  formsArr[formObj].modalObj.open = true;
  scrollHandler.disableScroll();
  // add support for older browsers
  try {
    formsArr[formObj].containerEl.showModal();
  } catch (e) {
    formsArr[formObj].containerEl.setAttribute("isFallback", "true");
    formsArr[formObj].isFallback = true;
  }
  // we blur the first field of the modal form when we open it as per design's request
  formsArr[formObj].containerEl
    .querySelector(
      'input[name="' + Object.keys(formsArr[formObj].modalObj.fields)[0] + '"]'
    )
    .blur();
  routemParticleHandler.logLeadFormViewedEvent(formsArr[formObj].formVersion);
}

function customCloseModal(formsArr, formObj) {
  formsArr[formObj].modalObj.open = false;
  if (!formsArr[formObj].isFallback) {
    formsArr[formObj].containerEl.close();
  } else {
    formsArr[formObj].containerEl.removeAttribute("isFallback");
  }
  scrollHandler.enableScroll();
}
